module.exports = __webpack_public_path__ + "themify.a1ecc3b826d01251eddd.woff";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/themify-icons/fonts/themify.woff
// module id = ../../../../../src/scss/icons/themify-icons/fonts/themify.woff
// module chunks = styles